<template>
  <main class="container">
    <slot />
  </main>
</template>

<script>
export default {
  name: 'CContainer'
}
</script>

<style lang="scss">
@import "../css/variables";

.container {
  width: ($container-width + $gutter-lg * 2);
  max-width: 100%;
  margin: auto;

  @media (min-width: $breakpoint-sm) {
    padding: 0 $gutter-sm;
  }

  @media (min-width: $breakpoint-md) {
    padding: 0 $gutter-md;
  }

  @media (min-width: $breakpoint-lg) {
    padding: 0 $gutter-lg;
  }

  @media print {
    width: 100%;
    padding: 0;
  }
}
</style>
